export default __webpack_public_path__ + "static/media/bxs--offer.59283879.svg";